import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';

export class Webinar extends Model<Schemas['webinars'], Models> {}
